import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import type { PlatformApi } from '../../../common/controller/platform-api';
import { encodeURIComponentIfNeeded } from '../../../common/services/uri';

export const customRouteHandler = async (platformApi: PlatformApi) => {
  const url = platformApi.location.url.startsWith(platformApi.location.baseUrl)
    ? platformApi.location.url
    : // Edge case: When clicking "Preview" in Editor:
      // getCustomizedUrlSegments requires the url to start with baseUrl
      `${platformApi.location.baseUrl}/${platformApi.location.path.join('/')}`;

  const { key, segments } = (await platformApi?.site?.getCustomizedUrlSegments?.(url)) || {};

  if (!key || !segments) {
    return null;
  }

  const slug = encodeURIComponentIfNeeded(segments.slug);
  const instance = encodeURIComponentIfNeeded(segments.instance);

  const routeMap = {
    [UrlMappingsKeys.BLOG_POST]: `/${slug}`,
    [UrlMappingsKeys.BLOG_POST_PREVIEW]: `/${slug}/preview/${instance}`,
  };

  return routeMap[key as keyof typeof routeMap] || null;
};
